/* eslint-disable */
import React from 'react';
import { Row, Col, Container } from 'reactstrap';

const TeamComponent = () => {
    return (
        <div>
            <div className="spacer team2">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="7" className="text-center">
                            <h1 className="title font-bold p-b-20">Team</h1>
                            <p>The creative crew behind Convext.</p>
                        </Col>
                    </Row>
                    <Row className="m-t-30">
                        <Col lg="4" md="6" className="m-b-30">
                            <Row className="no-gutters">
                                <Col md="12" className="pro-pic t1">
                                    <div className="card-img-overlay">
                                        <ul className="list-inline">
                                            <li className="list-inline-item"><a ><i className="fa fa-facebook"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-twitter"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-instagram"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-behance"></i></a></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="12">
                                    <div className="p-t-10 text-center">
                                        <h5 className="title font-medium">Bhanu Kushwah</h5>
                                        <h6 className="subtitle">Full Stack Developer</h6>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="4" md="6" className="m-b-30">
                            <Row className="no-gutters">
                                <Col md="12" className="col-md-12 pro-pic t2">
                                    <div className="card-img-overlay">
                                        <ul className="list-inline">
                                            <li className="list-inline-item"><a ><i className="fa fa-facebook"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-twitter"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-instagram"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-behance"></i></a></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="12">
                                    <div className="p-t-10 text-center">
                                        <h5 className="title font-medium">Prapti Pagnis</h5>
                                        <h6 className="subtitle">Frontend Developer</h6>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="4" md="6" className="m-b-30">
                            <Row className="no-gutters">
                                <Col md="12" className="col-md-12 pro-pic t3">
                                    <div className="card-img-overlay">
                                        <ul className="list-inline">
                                            <li className="list-inline-item"><a ><i className="fa fa-facebook"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-twitter"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-instagram"></i></a></li>
                                            <li className="list-inline-item"><a ><i className="fa fa-behance"></i></a></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="12">
                                    <div className="p-t-10 text-center">
                                        <h5 className="title font-medium">Alina Khan</h5>
                                        <h6 className="subtitle">Frontend Developer</h6>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default TeamComponent;
